// extracted by mini-css-extract-plugin
export default {"greyed":"StartErrorInspector_greyed__KvNRB","logo":"StartErrorInspector_logo__Jd7Mi"};